import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-household-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_459_2105)">
        <path
          d="M12.1411 12.632L15.8531 8.91997L17.4441 4.14697L20.6261 0.964966"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0799 11.571L2.06388 14.342C1.8753 14.4028 1.7171 14.5334 1.62172 14.7071C1.52634 14.8807 1.50099 15.0843 1.55088 15.276C2.27515 17.066 3.35215 18.6919 4.71776 20.057C6.08338 21.4221 7.70969 22.4985 9.49988 23.222C9.69176 23.2717 9.89535 23.2463 10.0691 23.151C10.2429 23.0556 10.3737 22.8976 10.4349 22.709L13.2049 13.693L11.0799 11.571Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.10708 16.3101L3.15308 18.1931"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.46208 18.666L6.58008 21.62"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.7729 15C19.7675 15 20.7213 15.3951 21.4246 16.0983C22.1278 16.8016 22.5229 17.7554 22.5229 18.75V19.125C22.5229 19.8208 22.2466 20.4882 21.7548 20.9804C21.2629 21.4727 20.5957 21.7495 19.8999 21.75C19.4026 21.75 18.9257 21.5525 18.5741 21.2008C18.2224 20.8492 18.0249 20.3723 18.0249 19.875C18.0249 19.3777 18.2224 18.9008 18.5741 18.5492C18.9257 18.1975 19.4026 18 19.8999 18"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.02295 7.5C8.02839 7.5 7.07456 7.10491 6.3713 6.40165C5.66804 5.69839 5.27295 4.74456 5.27295 3.75V3.375C5.27295 3.03011 5.34091 2.6886 5.47296 2.36999C5.605 2.05138 5.79854 1.76192 6.0425 1.51814C6.28647 1.27436 6.57608 1.08104 6.89479 0.949243C7.2135 0.817442 7.55506 0.749738 7.89995 0.750001C8.39723 0.750001 8.87414 0.947545 9.22577 1.29918C9.57741 1.65081 9.77495 2.12772 9.77495 2.625C9.77495 3.12228 9.57741 3.5992 9.22577 3.95083C8.87414 4.30246 8.39723 4.5 7.89995 4.5"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_459_2105">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class HouseholdInsuranceIconComponent extends BaseIconComponent {}
